import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const nebankaRoute = createRoute({
	path: '/nebanka',
	getParentRoute: () => clientRoute,
});
